import {
  Button,
  Dialog,
  Grid,
  Theme,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useLocation, useNavigate } from 'react-router-dom';
import { verifyingInfoBackButtonClicked, verifyingInfoSupportButtonClicked } from '../fullstory-events/events';

interface Props {}

const useStyles = makeStyles((theme: Theme) => ({
  wrapper: {
    height: '100vh',
    background: '#F9FAFB',
  },
  header: {
    padding: 36,
  },
  paper: {
    justifyContent: 'center',
    [theme.breakpoints.down('md')]: {
      padding: '0px 20px',
    },
  },
  headingText: {
    textAlign: 'center',
    margin: '8px 0px',
    [theme.breakpoints.down('md')]: {
      fontSize: 24,
      fontWeight: 700,
    },
    [theme.breakpoints.up('md')]: {
      fontSize: 32,
      fontWeight: 600,
    },
  },
  bodyText: {
    textAlign: 'center',
    fontWeight: 500,
    fontSize: 18,
    color: '#718096',
    margin: '8px 0px',
    [theme.breakpoints.down('md')]: {
      fontSize: 14,
    },
  },
  buttonText: {
    textTransform: 'capitalize',
    fontWeight: 700,
  },
}));

function VerifyingInfoPage(props: Props) {
  const { state } = useLocation();
  const chosenDotEmail = state.chosenDotEmail;
  const classes = useStyles();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const navigate = useNavigate();

  const handleClick = () => {
    verifyingInfoBackButtonClicked({ email: chosenDotEmail });
    navigate('/registration/start-application');
  };

  return (
    <div className={classes.wrapper}>
      <div className={classes.header}>
        <img src={require('#app/icons/TNLogo.svg').default} alt="TNLogo" />
      </div>
      <Dialog
        open={true}
        fullScreen={fullScreen}
        maxWidth="md"
        fullWidth
        BackdropProps={{
          style: {
            backgroundColor: 'transparent',
          },
        }}
        PaperProps={{ elevation: 0 }}>
        <Grid container>
          <Grid item md={3} />
          <Grid container item xs={12} md={6} className={classes.paper}>
            <img
              src={require('#app/icons/Progress.svg').default}
              alt="progress"
              style={{ height: 160, marginBottom: 32, marginTop: 52 }}
            />
            <div className={classes.headingText}>Confirm your email address</div>
            <div className={classes.bodyText}>
              We have sent an email to:
              <br />
              <br />
              <b>{chosenDotEmail}</b>
              <br />
              <br />
              Check your email and click on the confirmation link to continue registration
            </div>
            <Button
              data-testid="contact-support"
              fullWidth
              href="mailto:onboardingcustomersupport@truenorthfleet.com"
              onClick={() => verifyingInfoSupportButtonClicked({ email: chosenDotEmail })}
              style={{ height: 56, marginTop: 32 }}
              variant="outlined">
              <span className={classes.buttonText}>Contact Support</span>
            </Button>
            <Button
              data-testid="back"
              fullWidth
              onClick={handleClick}
              style={{ height: 56, margin: '32px 0px 160px' }}>
              <span className={classes.buttonText}>Back</span>
            </Button>
          </Grid>
          <Grid item md={3} />
        </Grid>
      </Dialog>
    </div>
  );
}

export default VerifyingInfoPage;
